import { createFileRoute } from "@tanstack/react-router";
import { OmPage } from "./om";

export const Route = createFileRoute("/en/about")({
  head: () => ({
    meta: [
      { title: "About Sellavo – photograph or film, we write the listing" },
      { name: "description", content: "Sellavo turns your photos or video into a finished listing with title, text and price." },
      { property: "og:title", content: "About Sellavo – photograph or film, we write the listing" },
      { property: "og:description", content: "Sellavo turns your photos or video into a finished listing with title, text and price." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/about" }],
  }),
  component: OmPage,
});
